import {
  createOrder,
  deleteOrder,
  listDataOrder,
  consultProgress,
  getOrder,
  getByOrderNo,
  refundTeacherAudit,
  appealList,
  queryAppealMaterial,
  addAppealMaterial,
  orderGiveListData,
  excelListOrder
} from '@/zsm-api-new/order.js'
import { afterSaleListData, queryOrderAfterSaleNum30 } from '@/zsm-api-new/order.js' // 售后信息
const state = {
  orderDetailDrawer:false ,//详情弹框
  orderDetailInfo:'' ,//弹框的订单信息
  distUserInfo:'' ,//弹框的订单达人信息
  
}

const mutations = {

}

const actions = {
  /**
   * 获取举证材料列表
   * @param orderId 订单编号
   */
  queryAppealMaterial({ commit }, info) {
    return new Promise((resolve, reject) => {
      queryAppealMaterial(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  /**
   * 添加举证材料
   * @param appealId 申诉id
   * @param  appealType 1买家 2卖家 3平台
   * @param  appealReason 举证原因
   * @param  appealImages 举证图片
   * */
  addAppealMaterial({ commit }, info) {
    return new Promise((resolve, reject) => {
      addAppealMaterial(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  /**
   * 申诉列表
   * @param authorMObile 讲师账号
   */
  appealList({ commit }, info) {
    return new Promise((resolve, reject) => {
      appealList(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  /**
   * 投诉近三十天数据
   * @param teacherMobile 讲师账号
   * @returns {*}
   */
  queryOrderAfterSaleNum30({ commit }, info) {
    return new Promise((resolve, reject) => {
      queryOrderAfterSaleNum30(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  /**
   * 售后详情内容
   * @param teacher_mobile 讲师账号
   * @param order_no 订单号
   * @param good_id 商品id
   * @param buyer_name 买家姓名
   * @param buyer_mobile 买家手机号
   * @param applyBeginDate 申请开始售后时间
   * @param applyEndDate 申请售后结束时间
   * @param platformDict 平台类型
   * @param afterSaleProgress 售后状态
   * @returns {*}
   */
  afterSaleListData({ commit }, info) {
    return new Promise((resolve, reject) => {
      afterSaleListData(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  /**
   * 根据订单号获取赠送订单列表
   *  @param id 订单id
   *  @param orderId 父订单
   *  @param pageNo 当前页
   *  @param pageSize 每页条数
   */
  orderGiveListData({ commit }, info) {
    return new Promise((resolve, reject) => {
      orderGiveListData(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },




  // 咨询类-更改订单状态
  consultProgress({
    commit
  }, info) {
    return new Promise((resolve, reject) => {
      consultProgress(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 讲师审核退款
  // refundAuditOrder({ commit }, info) {
  //   return new Promise((resolve, reject) => {
  //     refundAuditOrder(info).then(response => {
  //       resolve(response)
  //     }).catch(error => {
  //       reject(error)
  //     })
  //   })
  // },

  /**
   * 讲师审核退款
   * @param orderId 订单id
   * @param refnAuditProgress 修改的状态  同意则变为agree,拒绝显示reject
   * @param refondauditheson 审核原因
   * @param refundAuditReason 拒绝原因
   * @param refundAvditIagelne 凭证图
   */
  refundTeacherAudit({ commit }, info) {
    return new Promise((resolve, reject) => {
      refundTeacherAudit(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },




  /**
   * 查看一个订单
   *  @param orderNo 订单orderNo
   */
  getByOrderNo({ commit }, info) {
    return new Promise((resolve, reject) => {
      getByOrderNo(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  /**
   * 查看一个订单
   *  @param id 订单id
   */
  getOrder({ commit }, info) {
    return new Promise((resolve, reject) => {
      getOrder(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  
  // 订单导出
  excelListOrder({
    commit
  }, info) {
    return new Promise((resolve, reject) => {
      excelListOrder(info).then(response => {
        response={
          list:response
        }
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取订单列表
  listDataOrder({
    commit
  }, info) {
    return new Promise((resolve, reject) => {
      listDataOrder(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 删除订单
  deleteOrder({
    commit
  }, id) {
    return new Promise((resolve, reject) => {
      createOrder(id).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 创建订单
  createOrder({
    commit
  }, info) {
    return new Promise((resolve, reject) => {
      createOrder(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
